<template>
	<div class="app-topic"
		:class="[
			`app-topic--bg-${generateRandomNamber(9)}`,
			`app-topic--icon-${generateRandomNamber(22)}`,
			{
				'app-topic--brend': search,
				'app-topic--brend': preset && topic.is_private
			}
		]"
	>
		<header class="app-topic__header">
			<h1 class="app-topic__title">
				{{ topic.title }}
				<span v-if="topic.courses.length" class="flag flag--base-font-color">{{ topic.courses.length }}</span>
			</h1>

			<div v-if="false" class="app-topic__header-bottom courses-filters">
				<label class="labeled-field labeled-field--search labeled-field--topic">
					<input
						placeholder="Поиск"
						type="text"
						class="labeled-field__input"
						ref="searchInput"
						@input="searchOnInput"
						v-model="searchModel"
					>
					<button
						class="remove-btn remove-btn--tiny remove-btn--red hide"
						type="button"
						ref="clearSearchButton"
						@click="clearSearch"
					></button>
				</label>
				<section class="courses-filters__group courses-filters__group--select">
					<button class="courses-filters__btn" type="button">{{ sortingTitle }}</button>
					<div class="courses-filters__holder">
						<label v-for="(sortingItem, index) in sorting" :key="'sorting-' + index" class="course-select">
							<input
								class="course-select__input"
								type="radio"
								:value="sortingItem.value"
								v-model="sortingModel"
							>
							<span class="course-select__label">{{ sortingItem.title }}</span>
						</label>
					</div>
				</section>
				<section class="courses-filters__group courses-filters__group--filters">
					<button class="app-btn app-btn--sm app-btn--primary app-btn--filter" type="button">
						{{ $t('filters') }}
					</button>
					<div class="courses-filters__holder">
						<section class="courses-filters__section">
							<h3 class="courses-filters__title">{{ $t('types_of_courses') }}</h3>
							<ul class="courses-filters__list">
								<li
									v-for="(type, index) in courseTypes"
									:key="'topicFilter-' + index"
									class="courses-filters__item"
								>
									<label class="checkbox">
										<input
											type="checkbox"
											class="checkbox__input"
											:value="type"
											v-model="coursesTypesModel"
										/>
										<span class="checkbox__label">
											{{ $t(`course_types.${type}`) }}
										</span>
									</label>
								</li>
							</ul>
						</section>

						<section class="courses-filters__section">
							<label class="courses-radiobutton">
								<input
									class="courses-radiobutton__input"
									type="checkbox"
									value="completed_courses"
									v-model="completedCoursesModel"
								>
								<span class="courses-radiobutton__label">{{ $t('hide_completed_courses') }}</span>
							</label>
						</section>
						<div class="courses-filters__footer">
							<p class="light-font-color small-font-size">
								{{ $t('found')}}: {{ filteredCourses.length }}
							</p>
							<button class="regular-btn small-btn red-btn ml-auto" @click="clearFilters" type="button">{{ $t('buttons.clear_filters') }}</button>
						</div>
					</div>
				</section>
			</div>
		</header>

		<div class="app-topic__results">
			<template v-if="filteredCourses.length">
				<ul class="app-topic__list">
					<li
						v-for="(course, index) in filteredCourses"
						:key="'course-' + topic.id + '-' + index"
					>
						<AppCatalogCourse
							:course="course"
							:full_only="false"
							:finished="course.finished"
							:started="course.active"
							:bookmark="course.wished"
						/>
					</li>
				</ul>
			</template>

			<div v-else class="app-topic__message-holder">
				<p class="app-topic__message">
					{{ $t('messages.no_filters_message') }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import AppCatalogCourse from "./Catalog/AppCatalogCourse.vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import 'vue3-carousel/dist/carousel.css';

export default {
	name: 'Topic',

	components: {
		Carousel,
		Slide,
		Navigation,
		AppCatalogCourse,
	},

	props: {
		topic: Object,
		preset: { type: Boolean, default: false },
		search: { type: Boolean, default: false },
		current_company_name: ''
	},

	data() {
		return {
			сoursesCatalogName: '',
			loading: true,
			showFiltres: false,
			sortOrdered: false,
			coursesTypesModel: [],
			subjectsModel: [],
			// У подборки порядок курсов задаёт сервер (порядок задач пресета), поэтому сортировка по умолчанию не применяется.
			sortingModel: this.preset ? '' : 'popular',
			completedCoursesModel: '',
			showLoader: false,
			isWishedCourses: false,
			searchModel: '',
			sorting: [
				{ title: this.$t('sorting.popular'), value: 'popular'},
				{ title: this.$t('sorting.new_first'), value: 'order'},
				{ title: this.$t('sorting.sorting_AZ'), value: 'sortingAZ'},
				{ title: this.$t('sorting.sorting_ZA'), value: 'sortingZA'},
			]
		};
	},

	computed: {
		pagesCount() {
			return Math.ceil(this.itemsTotal / this.itemsPerPage);
		},

		coursesFilteredByType() {
			return this.coursesTypesModel.length
			? this.topic.courses.filter((course) =>
				this.coursesTypesModel.includes(course.type)
			)
			: this.topic.courses;
		},

		beginnerCourses() {
			return this.topic.courses.filter((course) => course.beginner);
		},

		subjects() {
			return [...new Set(this.topic.courses.flatMap((course) => course.course_tags))];
		},

		courseTypes() {
			return [...new Set(this.topic.courses.map((course) => course.type))];
		},

		sortingTitle() {
			return this.sorting.filter((item) => item.value === this.sortingModel).map(obj => obj.title)[0];
		},

		filteredCourses() {
			let courses = this.topic.courses;

			if (this.coursesTypesModel.length !== 0) {
				courses = courses.filter(
					(course) => this.coursesTypesModel.includes(course.type)
				)
			}

			if (this.subjectsModel.length !== 0) {
				courses = courses.filter(course =>
					course.course_tags.some(tag => this.subjectsModel.includes(tag))
				)
			}

			if (this.sortingModel === 'order') {
				courses = courses.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
			}

			if (this.sortingModel === 'sortingAZ') {
				courses = courses.sort((a, b) => a.name.localeCompare(b.name));
			}

			if (this.sortingModel === 'sortingZA') {
				courses = courses.sort((a, b) => b.name.localeCompare(a.name));
			}

			if (this.sortingModel === 'popular') {
				courses = courses.sort((a, b) => b.users_count - a.users_count);
			}

			if (this.completedCoursesModel) {
				courses = courses.filter((course) => !course.finished);
			}

			if (this.isWishedCourses) {
				courses = courses.filter((course) => course.wished);
			}

			if (this.searchModel.length !== 0) {
				let query = this.searchModel.toLowerCase();

				courses = courses.filter((course) => {
					if (course.name) {
						return course.name.toLowerCase().includes(query)
					}
				})
			}

			return courses;
		},
	},

	methods: {
		searchOnInput() {
			if (this.searchModel.length) {
				this.$refs.clearSearchButton.classList.remove('hide');
			} else {
				this.$refs.clearSearchButton.classList.add('hide');
			}
		},

		clearSearch() {
			this.$refs.searchInput.value = '';
			this.searchModel = '';
			this.$refs.clearSearchButton.classList.add('hide');
		},

		clearFilters() {
			this.subjectsModel = [];
			this.coursesTypesModel = [];
			this.completedCoursesModel = '';
		},

		generateRandomNamber(limit) {
			return Math.floor(Math.random() * limit) + 1;
		},

		showWishedCourses() {
			this.isWishedCourses = !this.isWishedCourses;
		}
	},
};
</script>

